import React from "react";
import { Navigate } from "react-router-dom";
import Menu from "@shared/layout/Menu";
import Programs from "@features/programs/components/Programs";
import programsRoutes from "@features/programs/routes";
import physioRoutes from "@features/physio/routes";
import preferencesRoutes from "@features/preferences/routes";
import materialsRoutes from "@features/materials/routes";
import publicAccessRoutes from "@features/public-access/routes";

const routes = [
  ...programsRoutes,
  ...physioRoutes,
  ...preferencesRoutes,
  ...materialsRoutes,
  ...publicAccessRoutes,
  {
    path: "*",
    element: (
      <>
        <Navigate to="/dashboard" />
        <Menu content={<Programs />} />
      </>
    ),
    isProtected: true,
  },
];

export default routes;
